export default __webpack_public_path__ + "static/media/team-play.13dabb19.png";